export default "__VITE_PUBLIC_ASSET__f5b8e168__"